import { createSlice } from "@reduxjs/toolkit";
import { ConfiguracaoImportacaoVendaModel } from "../../../models/configuracaoImportacaoVenda/configuracaoImportacaoVendaModel";
import { listarConfiguracaoImportacaoVenda } from "../../../services/configuracaoImportacaoVendaService";
import { BuscaConfiguracaoImportacaoVendaModel } from "../../../models/configuracaoImportacaoVenda/buscaConfiguracaoImportacaoVendaModel";
import { resetAll } from "../../actions/actions";

export interface ConfiguracaoImportacaoVendaState {
  //buscar configuracao importacao venda
  loading: boolean;
  busca: BuscaConfiguracaoImportacaoVendaModel;
  list: ConfiguracaoImportacaoVendaModel[];
  entity: ConfiguracaoImportacaoVendaModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: ConfiguracaoImportacaoVendaState = {
  //buscar configuracao importacao venda
  loading: false,
  busca: {} as BuscaConfiguracaoImportacaoVendaModel,
  list: [],
  entity: {} as ConfiguracaoImportacaoVendaModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const configuracaoImportacaoVendaSlice = createSlice({
  name: "configuracaoImportacaoVenda",
  initialState,
  reducers: {
    //buscar configuracao importacao venda
    setBuscaConfiguracaoImportacaoVenda: (state, action) => {
      state.busca = action.payload;
    },
    setEntityConfiguracaoImportacaoVenda: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarConfiguracaoImportacaoVenda: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarConfiguracaoImportacaoVenda: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    // builder.addCase(resetAll, () => initialState);

    //buscar configuracao importacao venda
    builder.addCase(listarConfiguracaoImportacaoVenda.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarConfiguracaoImportacaoVenda.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarConfiguracaoImportacaoVenda.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar configuracao importacao venda
  setBuscaConfiguracaoImportacaoVenda,
  setEntityConfiguracaoImportacaoVenda,
  //internal
  setModalCadastrarConfiguracaoImportacaoVenda,
  setModalDeletarConfiguracaoImportacaoVenda,
} = configuracaoImportacaoVendaSlice.actions;

export default configuracaoImportacaoVendaSlice.reducer;
